import i18n from 'i18n'

export enum WeekDay {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 0,
}

export const weekDayNames = (): Record<WeekDay, string> => ({
  [WeekDay.Monday]: i18n.t('monday'),
  [WeekDay.Tuesday]: i18n.t('tuesday'),
  [WeekDay.Wednesday]: i18n.t('wednesday'),
  [WeekDay.Thursday]: i18n.t('thursday'),
  [WeekDay.Friday]: i18n.t('friday'),
  [WeekDay.Saturday]: i18n.t('saturday'),
  [WeekDay.Sunday]: i18n.t('sunday'),
})
